import http from '../../utils/Http/Http'
import { getAuth } from 'firebase/auth'

export function runCampaign({ campaignId, testPhoneNumber, retryCampaign, agentId }) {
	const auth = getAuth()
	const user = auth.currentUser
	const params = {}

	if (testPhoneNumber) {
		params.test_phone_number = testPhoneNumber
		params.test_name = user.displayName
	} else if (retryCampaign) {
		params.retry_campaign = retryCampaign
	}

	if (agentId) {
		params.agent_id = agentId
	}

	return http({
		params,
		method: 'get',
		url: `/campaigns/run/${campaignId}`,
	})
}
